import * as ErrorFormat from './ErrorFormat';

import messages from './Message';
import notify from 'components/Notify';

export function display(err, autoHide = true) {
  let msg = ErrorFormat.format(err);
  if (
    !msg &&
    (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')
  ) {
    msg = messages.unknownError;
    notify(msg, 'error', autoHide, 10000);
  } else {
    notify(msg, 'error', autoHide, 10000);
  }
}
